import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

// reducers
import Login from './reducers/Login';
import Menu from './reducers/Menu'
import Modal from './reducers/Modal';
import Search from './reducers/Search';
import MultiBooking from './reducers/MultiBooking';
import Report from './reducers/Report';
import Create from './reducers/Create';
import Delete from './reducers/Delete';
import Edit from './reducers/Edit';

const rootReducers = combineReducers({
    Login,
    Menu,
    Modal,
    Search,
    MultiBooking,
    Report,
    Create,
    Delete,
    Edit
});

const store = createStore(rootReducers, composeWithDevTools(
    applyMiddleware(thunk)
));

export default store;